import { render, staticRenderFns } from "./learnMaterial.vue?vue&type=template&id=5b7b0756"
import script from "./learnMaterial.vue?vue&type=script&lang=js"
export * from "./learnMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports